import React from 'react';
import { signOut } from 'firebase/auth';
import { auth } from '../firebase';

function Header() {
  const handleLogout = async () => {
    if (window.confirm('Are you sure you want to logout?')) {
      await signOut(auth);
    }
  };

  return (
    <div className="header">
      <div className="header-left">
        <img 
          src="AAN Publishing Logo.png" 
          alt="AAN Publishing Logo" 
          className="header-logo" 
        />
        <h1>AAN Publishing - Admin Dashboard</h1>
      </div>
      <button className="logout-btn" onClick={handleLogout}>
        Logout
      </button>
    </div>
  );
}

export default Header;
